import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { Store } from '@ngxs/store';
import { VxButtonComponent } from '@ui/button/button.component';
import { FeaturesState } from 'src/app/store/features/features.state';
import { FLAGS } from 'src/app/store/features/flags';
import { AuthHeaderComponent } from '../components/auth-header/auth-header.component';
import { AuthHelpComponent } from '../components/auth-help/auth-help.component';
import { AuthShellComponent } from '../components/auth-shell/auth-shell.component';

/** Shown while the maintenance flag is on; offers the way back once it's off. */
@Component({
  selector: 'app-page-maintenance',
  templateUrl: './maintenance.component.html',
  imports: [
    TranslocoModule,
    AuthHeaderComponent,
    AuthHelpComponent,
    AuthShellComponent,
    VxButtonComponent,
  ],
})
export class MaintenancePageComponent {
  private readonly store = inject(Store);
  private readonly router = inject(Router);

  protected readonly maintenanceEnabled = this.store.selectSignal(
    FeaturesState.boolFlag(FLAGS.HALO_PROTOCOL_FRONTENT)
  );

  protected returnToDashboard(): void {
    this.router.navigate(['/']);
  }
}
